import r from "./highrise1302.mjs";
import a from "./highrise1303.mjs";
import p from "./highrise1304.mjs";
import s from "./highrise1305.mjs";
import i from "./highrise1306.mjs";
import m from "./highrise1307.mjs";
function t(o) {
  var e = this.__data__ = new r(o);
  this.size = e.size;
}
t.prototype.clear = a;
t.prototype.delete = p;
t.prototype.get = s;
t.prototype.has = i;
t.prototype.set = m;
export {
  t as default
};
